import { Form, Select, Input, Modal, message } from 'antd';
import { modifyOmsRecycleOrderPayoutDetail } from 'apis/oms';
import { useEffect } from 'react';
import { PaymentMethod } from 'constants/RecyclingConsignment';
import { OmsRecycleOrderDetail } from 'types/oms';
import i18n from '../../../i18n';
import LOCALS from '../../../commons/locals';

type Props = {
  open: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  dataSource: OmsRecycleOrderDetail;
};

const ModifyPayment = ({ open, onCancel, onSuccess, dataSource }: Props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;
    const { id, settlementType, payoutDetail } =
      dataSource.omsRecycleOrder || {};

    form.setFieldsValue({
      id,
      settlementType,
      payoutDetail: payoutDetail || '',
    });
  }, [open, form, dataSource.omsRecycleOrder]);

  return (
    <Modal
      open={open}
      title={i18n.t(LOCALS.update_payment_information)}
      width={600}
      onCancel={onCancel}
      onOk={async () => {
        const { payoutDetail, settlementType, id } = form.getFieldsValue();

        if (!id) return;
        if (!settlementType) return;

        await modifyOmsRecycleOrderPayoutDetail({
          omsRecycleOrderId: id,
          payoutDetail: payoutDetail || '',
          settlementType,
        });

        message.success(i18n.t(LOCALS.successful_operation));
        onSuccess();
      }}
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        initialValues={{
          id: dataSource.omsRecycleOrder?.id,
        }}
      >
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
        <Form.Item
          label={i18n.t(LOCALS.payment_method)}
          name="settlementType"
          rules={[{ required: true }]}
        >
          <Select options={PaymentMethod} />
        </Form.Item>

        <Form.Item label={i18n.t(LOCALS.payment_details)} name="payoutDetail">
          <Input.TextArea autoSize={{ minRows: 4, maxRows: 6 }} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModifyPayment;
